
export const generateSectionHtml = (data) => {
  return `${
        data?.html? `<div class="preview-inner" style="margin :0px 0px; background-color: ${data?.bgColor || "#ffffff"};color: ${data?.textColor || "#00000"}; font-size: 14px; ">${data?.html}</div> `
          : "" }`;
};
export const generateTemplate = (setting, custom = {}) => {
  const baseDefaults = setting || {};

  return {
      body: {
        ...(baseDefaults?.body || {}),
        ...(custom?.body || {}),
      },
      subject: custom?.subject || baseDefaults.subject,
      id: baseDefaults.id,
      name: baseDefaults.name,
   
    html: custom?.html|| baseDefaults?.html
  };
};


// Time Ago
export const timeAgo = (dateString) => {
  const now = new Date();
  const date = new Date(dateString);
  const seconds = Math.floor((now - date) / 1000);

  const intervals = {
    year: 31536000,
    month: 2592000,
    week: 604800,
    day: 86400,
    hour: 3600,
    minute: 60,
  };

  const weekday = date.toLocaleDateString("en-US", {
    weekday: "short", // Mon, Tue, Wed...
  });

  for (const unit in intervals) {
    const value = Math.floor(seconds / intervals[unit]);
    if (value >= 1) {
      return `${value} ${unit}${value > 1 ? "s" : ""} ago (${weekday})`;
    }
  }

  return `just now (${weekday})`;
};

// Copy Handler
export const copyToClipboard = (text, cb) => {
  navigator.clipboard.writeText(text);
  cb(true);
};

export function cleanQuillHtml(html) {
  return html.replace(/<p><br><\/p>/g, "<br>");
}